const MembershipStatus = Object.freeze({
  ACTIVE: 'Active',
  CANCELED: 'Canceled',
  OVERDUE: 'Overdue',
});

export default MembershipStatus;
